<script>
import { Chrome } from "vue-color";
import { authComputed } from "@/state/helpers";
import InboxService from "@/helpers/APIService/inbox.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      tagsOptions: [],
      toUpdatetag: false,
      submittedTag: false,
      tagged: {
        name: null,
        color: "#000000",
        is_active: true,
        value: null,
      },
    };
  },
  props: {
    tagOptionsAvail: Array,
  },
  emits: ["updateTags"],
  components: {
    "chrome-picker": Chrome,
  },
  mounted() {
    this.tagsOptions = this.tagOptionsAvail;
    this.$root.$on("chatTagOptions", (data) => {
      this.tagsOptions = data;
    });
  },
  computed: {
    ...authComputed,
  },
  validations: {
    tagged: {
      name: { required },
      color: { required },
    },
  },
  methods: {
    tags(data) {
      this.activeUser = null;
      this.allChatData = [];
      for (let index = 0; index < this.chatData.length; index++) {
        if (this.chatData[index].group_tags.includes(data.value)) {
          this.allChatData.push(this.chatData[index]);
        }
      }
      for (let index = 0; index < this.groupChatData.length; index++) {
        if (this.groupChatData[index].group_tags.includes(data.value)) {
          this.allChatData.push(this.groupChatData[index]);
        }
      }
    },
    resetTag(data) {
      this.toUpdatetag = true;
      this.tagged.name = data.name;
      this.tagged.color = data.color;
      this.tagged.is_active = data.is_active;
      this.tagged.value = data.value;
      this.$bvModal.show("update-tags");
    },
    cancelTagSubmit() {
      this.$bvModal.hide("update-tags");
      this.tagged.name = null;
      this.tagged.color = "#000000";
      this.tagged.is_active = false;
      this.toUpdatetag = false;
    },
    async handleUpdateTagSubmit(data) {
      this.submittedTag = true;
      this.$v.tagged.$touch();
      if (this.$v.tagged.$invalid) {
        return;
      } else {
        if (!this.toUpdatetag) {
          data = { ...data, hotel: this.user.user.id, color: data.color.hex };
          let tagData = new FormData();
          tagData.append(
            "color",
            data.color != undefined ? data.color : "#000000"
          );
          tagData.append("hotel", this.hotel.id);
          tagData.append("is_active", data.is_active);
          tagData.append("name", data.name);

          const response = await InboxService.addTagsOfGroup(tagData);
          if (response) {
            this.tagsOptions.push(response);
            Middleware.notification("Successfully added!", "success");
            this.$bvModal.hide("update-tags");
          }
          this.submittedTag = false;
          setTimeout(() => {
            this.$emit("updateTags");
          }, 1000);
        } else {
          try {
            let newData = {
              name: data.name,
              color: data.color.hex,
              is_active: data.is_active,
            };
            const response = InboxService.editTagsOfGroup(
              this.tagged.value,
              newData
            );
            if (response) {
              Middleware.notification("Successfully updated !!", "success");
              this.$bvModal.hide("update-tags");
            }
            this.submittedTag = false;
            setTimeout(() => {
              this.$emit("updateTags");
            }, 1000);
          } catch (error) {
            errorHandler(error);
          }
          this.submittedTag = false;
        }
      }
    },
  },
};
</script>
<template>
  <div class="mail-list mt-2">
    <div v-for="data in tagsOptions" :key="data.value">
      <a :style="{ color: [data.color] }">
        <i class="mdi mdi-tag-text-outline me-1 fs-5"></i>
        <span class="cursor" @click="tags(data)">{{ data.name }}</span>
        <i
          v-if="user.user.message_app_setting.is_edit_group_tag_setting"
          class="bx bx-pencil float-end fs-5"
          @click="resetTag(data)"
        ></i>
      </a>
    </div>
    <!-- Modal is to add new tag or update-->
    <b-modal
      id="update-tags"
      centered
      :title="toUpdatetag ? 'Update Tag' : 'Add New Tag'"
      hide-footer
      title-class="font-18"
      @hidden="cancelTagSubmit"
    >
      <form ref="form">
        <div class="row">
          <div class="col-md-6">
            <b-form-group class="mb-3">
              <label for="group_name_tag">
                Tag Name <span class="text-danger">*</span>
              </label>
              <b-form-input
                id="name-input"
                v-model.trim="tagged.name"
                placeholder="Enter tag name"
                autocomplete="off"
                type="text"
                :class="{
                  'is-invalid': submittedTag && $v.tagged.name.$error,
                }"
              ></b-form-input>
              <div
                v-if="submittedTag && $v.tagged.name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.tagged.name.required">Name is required.</span>
              </div>
            </b-form-group>
            <span class="text-primary" v-if="toUpdatetag">{{
              tagged.is_active ? "Active" : "Inactive"
            }}</span>
            <div
              class="form-check form-switch-md form-switch"
              slot="is_active"
              v-if="toUpdatetag"
            >
              <input
                class="form-check-input"
                v-model="tagged.is_active"
                type="checkbox"
                :class="{
                  'is-invalid': submittedTag && $v.tagged.color.$error,
                }"
              />
              <div
                v-if="submittedTag && $v.tagged.color.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.tagged.color.required">Color is required.</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <chrome-picker v-model="tagged.color" />
          </div>
          <div class="col-md-12">
            <hr />
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelTagSubmit"
              >Cancel
            </b-button>
            <b-button
              @click="handleUpdateTagSubmit(tagged)"
              class="float-end"
              variant="outline-primary"
              :class="{ disabled: submittedTag }"
            >
              <i
                v-if="submittedTag"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i>
              {{ toUpdatetag ? "Update" : "Add" }}
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
